import { DefaultValues } from 'react-hook-form';

import {
  CompanyLegalBeneficiary,
  CompanySupposedBeneficiary,
} from '../../../../__generated__/GQL';
import { Gender } from '../../../../common/types';
import { GetBeneficiariesDataQuery } from '../../modules/Beneficiaries/graphql/queries/getBeneficiariesData.gql';
import {
  BeneficiarySchema,
  BeneficiarySchemaWithEmail,
} from './beneficiarySchema';

function hasInvitation(
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary,
): beneficiary is CompanyLegalBeneficiary {
  return 'invitation' in beneficiary;
}
export const formatCompanyBeneficiaryToBeneficiaryFormInput = (
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary | null,
): DefaultValues<BeneficiarySchema> => {
  return {
    firstName: beneficiary?.firstName ?? '',
    gender: (beneficiary?.gender ?? undefined) as Gender | undefined,
    isDirector: beneficiary?.isDirector ?? undefined,
    isMajorShareholder: beneficiary?.isMajorShareholder ?? undefined,
    lastName: beneficiary?.lastName ?? '',
  };
};

export const formatCompanyBeneficiaryToBeneficiaryFormWithEmailInput = (
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary | null,
): DefaultValues<BeneficiarySchemaWithEmail> => {
  return {
    ...formatCompanyBeneficiaryToBeneficiaryFormInput(beneficiary),
    inviteeEmail:
      beneficiary &&
      hasInvitation(beneficiary) &&
      beneficiary?.invitation?.inviteeEmail
        ? beneficiary?.invitation?.inviteeEmail
        : '',
  };
};

export type CurrentBeneficiariesEmails = Set<string>;
export const getCurrentBeneficiariesEmails = ({
  accountHolderEmail,
  beneficiaries,
}: {
  beneficiaries: GetBeneficiariesDataQuery['viewer']['company']['legalBeneficiaries'];
  accountHolderEmail: string | null;
}) => {
  const beneficiaryEmails = new Set<string>();
  beneficiaryEmails.add(accountHolderEmail ?? '');
  beneficiaries.forEach((beneficiary) => {
    if (beneficiary?.invitation?.inviteeEmail) {
      beneficiaryEmails.add(beneficiary.invitation.inviteeEmail);
    }
  });

  return beneficiaryEmails;
};
